import * as Sentry from '@sentry/react';
import _ from 'axios';
import Cookies from 'js-cookie';
const bareBaseUrl = import.meta.env.VITE_API_URL;
const baseUrl = `${bareBaseUrl}/api/v1`;
const rssbMockBaseUrl = `${bareBaseUrl}/rssb_mock/api/v1`;
const rssbIntegrationBaseUrl = `${bareBaseUrl}/rssb_integration`;

export const api = _.create({
   baseURL: baseUrl,
});

export const AuthApi = _.create({
   baseURL: baseUrl,
   headers: {
      Authorization: `Bearer ${Cookies.get('token')}`,
   },
});
export const axios = _.create({
   baseURL: baseUrl,
   headers: {
      'x-api-key': 'honored-guest-123',
      Authorization: `Bearer ${Cookies.get('token')}`,
      'ngrok-skip-browser-warning': '69420',
   },
});

// Add request interceptor
axios.interceptors.request.use(
   (config) => {
      // Track API calls
      Sentry.addBreadcrumb({
         category: 'xhr',
         message: `${config.method?.toUpperCase()} ${config.url}`,
         level: 'info',
      });
      return config;
   },
   (error) => {
      Sentry.captureException(error);
      return Promise.reject(error);
   },
);

// Add response interceptor
axios.interceptors.response.use(
   (response) => response,
   (error) => {
      Sentry.captureException(error);
      return Promise.reject(error);
   },
);

// rssbMockAxios that extends axios
export const rssbMockAxios = axios.create({
   baseURL: rssbMockBaseUrl,
});

// rssbIntegrationAxios that extends axios
export const rssbIntegrationAxios = axios.create({
   baseURL: rssbIntegrationBaseUrl,
});

// insuranceIntegrationAxios for the unified insurance integration API v2
const insuranceIntegrationBaseUrl = `${bareBaseUrl}/insurance_integration/api/v2`;
export const insuranceIntegrationAxios = axios.create({
   baseURL: insuranceIntegrationBaseUrl,
});

export default axios;
